import React, { useState } from 'react'
import { Checkbox } from 'antd'
import { WarningOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

import Portal from '../Portal'
import SButton from '../SButton'

import './index.css'

const DANGER = 'danger'

export default function Confirm({
    onConfirm,
    onCancel = () => {},
    title,
    message,
    children,
    type = DANGER,
    className,
    style,
    needConfirm = true,
    isInfoOnly = false,
    conditionalConfirm = false,
    doubleConfirmation = false,
    doubleConfirmationMessage = 'I confirm',
}) {
    const { t } = useTranslation()

    const [isOpen, setIsOpen] = useState(false)
    const [acceptDoubleConfirmation, setAcceptDoubleConfirmation] = useState(false)

    const HandleOpenClick = (event) => {
        event.stopPropagation()
        if (needConfirm) {
            setIsOpen(true)
            setAcceptDoubleConfirmation(false)
        } else {
            onConfirm()
        }
    }

    const HandleConfirmClick = (event) => {
        event.stopPropagation()

        if (!conditionalConfirm) {
            setIsOpen(false)
            onConfirm()
        } else {
            if (onConfirm()) {
                setIsOpen(false)
            }
        }
    }

    const HandleCancelClick = (event) => {
        event.stopPropagation()
        setIsOpen(false)
        onCancel()
    }

    const HandleOutsideClick = (event) => {
        event.stopPropagation()
        if (event.target === event.currentTarget) {
            setIsOpen(false)
            onCancel()
        }
    }

    return (
        <>
            {isOpen && (
                <Portal id="model-confirm">
                    <div className="confirm-container" onClick={HandleOutsideClick}>
                        <div className="confirm-body">
                            <h3>
                                {type === DANGER ? <WarningOutlined style={{ color: 'red' }} /> : ''} {title}
                            </h3>
                            <div className="confirm-message">
                                {message}

                                {doubleConfirmation && (
                                    <Checkbox
                                        checked={acceptDoubleConfirmation}
                                        onChange={(e) => setAcceptDoubleConfirmation(e.target.checked)}
                                    >
                                        {doubleConfirmationMessage}
                                    </Checkbox>
                                )}
                            </div>
                            <div className="confirm-action-buttons">
                                <SButton value={isInfoOnly ? t('Close') : t('Cancel')} outlined onClick={HandleCancelClick} />
                                {!isInfoOnly && (
                                    <SButton
                                        value={t('Confirm')}
                                        type={type}
                                        onClick={HandleConfirmClick}
                                        disabled={doubleConfirmation && !acceptDoubleConfirmation}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </Portal>
            )}
            <div onClick={HandleOpenClick} className={className} style={style}>
                {children}
            </div>
        </>
    )
}
